import { render } from "./tabAddProcess.vue?vue&type=template&id=4fc8d9e3&scoped=true"
import script from "./tabAddProcess.vue?vue&type=script&lang=js"
export * from "./tabAddProcess.vue?vue&type=script&lang=js"

import "./tabAddProcess.vue?vue&type=style&index=0&id=4fc8d9e3&scoped=true&lang=css"

import exportComponent from "/Users/home/Documents/kevin/migration_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc8d9e3"]])

export default __exports__